import { render } from "./GramPanchayat.vue?vue&type=template&id=e43ea22a&scoped=true"
import script from "./GramPanchayat.vue?vue&type=script&lang=js"
export * from "./GramPanchayat.vue?vue&type=script&lang=js"

import "./GramPanchayat.vue?vue&type=style&index=0&id=e43ea22a&scoped=true&lang=scss"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e43ea22a"]])

export default __exports__